/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconJewishStar = createReactComponent("outline", "jewish-star", "IconJewishStar", [["path", { "d": "M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z", "key": "svg-0" }]]);

export { IconJewishStar as default };
//# sourceMappingURL=IconJewishStar.mjs.map
